import { Box, Checkbox, Grid, Typography } from '@mui/material';
import { KeyValue } from './InvestorWithoutPan/contributor';
import { SubHeading } from '../investors/components';
import React from 'react';
import { Gridstyles } from './index';
import { Applicant } from '../../redux-store/types/api-types';
import { ReasonMaster, USPersonDateValidation } from '../../utils/constant';
import {
  checkValidationBasedOnDate,
  FatcaDeclaration,
  isRiOutboundFund,
} from '../../utils/utilityFunctions';

export default function FatcaDetails({
  applicants = [],
  createdAt,
  schemeId = '',
}: {
  applicants: Partial<Applicant>[];
  createdAt: string;
  schemeId?: string;
}): JSX.Element {
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
              FATCA
            </Typography>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First/Solo Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading sx={{ letterSpacing: 0.5 + 'px' }}>{title}</SubHeading>

                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      {applicant.wishToUploadFatcaDocument && (
                        <Grid item xs={12} display="flex" alignItems={'flex-start'}>
                          {/* <Checkbox defaultChecked disabled={true} /> */}
                          <Typography
                            sx={{
                              fontSize: 15,
                              fontWeight: 700,
                              color: 'rgba(0, 0, 0, 0.6)',
                              letterSpacing: '0.5px',
                            }}>
                            {`Wish to upload FATCA-CRS Declaration`}
                          </Typography>
                        </Grid>
                      )}

                      {!applicant.wishToUploadFatcaDocument && (
                        <>
                          {!isRiOutboundFund(applicant.status, schemeId) && (
                            <KeyValue
                              title={'Type of Address proof provided'}
                              description={applicant.typeOfAddressProvidedAtKRA}
                            />
                          )}
                          <KeyValue
                            title={'Type of Address proof provided'}
                            description={applicant.typeOfAddressProvidedAtKRA}
                          />
                          <KeyValue
                            title={'Are you a tax resident of country other than India'}
                            description={applicant.taxIdResidentOfAnyCountryOtherThanIndia}
                          />
                          <KeyValue title={'Place Of Birth'} description={applicant.placeOfBirth} />
                          <KeyValue
                            title={'Country Of Birth'}
                            description={applicant.countryOfBirth}
                          />
                          <KeyValue
                            title={'Country of Citizenship/Nationality'}
                            description={applicant.countryOfNationality}
                          />
                          <KeyValue
                            title={'Country Of Residence'}
                            description={applicant.countryOfResidence}
                          />
                          {applicant.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' && (
                            <>
                              <KeyValue
                                title={'Country of Tax Residency/TIN Issuing Country'}
                                description={applicant.taxCountryName}
                              />
                              <KeyValue
                                title={'ID Type'}
                                description={
                                  applicant.idType === 'OTHERS'
                                    ? applicant.idTypeOthers
                                    : applicant.idType
                                }
                              />
                              <KeyValue
                                title={'Tax Identification Number (TIN)/Equivalent Number'}
                                description={applicant.taxID}
                              />
                              {applicant.idType === 'OTHERS' && (
                                <>
                                  <KeyValue
                                    title={'Reason (If TIN is not available)'}
                                    description={
                                      applicant.tinNotAvailableReason
                                        ? ReasonMaster[applicant.tinNotAvailableReason].code ===
                                          ReasonMaster.reason_a.code
                                          ? ReasonMaster.reason_a.description
                                          : ReasonMaster[applicant.tinNotAvailableReason].code ===
                                            ReasonMaster.reason_b.code
                                          ? ReasonMaster.reason_b.description
                                          : ReasonMaster[applicant.tinNotAvailableReason].code ===
                                            ReasonMaster.reason_c.code
                                          ? applicant.othersTinNotAvailableReason
                                          : ''
                                        : ''
                                    }
                                  />
                                </>
                              )}
                            </>
                          )}
                          {!checkValidationBasedOnDate(createdAt || '', USPersonDateValidation) && (
                            <KeyValue
                              title={'Are You a US Person'}
                              description={applicant.usPerson}
                            />
                          )}
                          {applicant.fatcaDeclaration && (
                            <Grid item xs={12} display="flex" alignItems={'flex-start'}>
                              {/* <Checkbox defaultChecked disabled={true} /> */}
                              <Typography
                                sx={{
                                  fontSize: 15,
                                  fontWeight: 700,
                                  color: 'rgba(0, 0, 0, 0.6)',
                                  letterSpacing: '0.5px',
                                }}>
                                {FatcaDeclaration(createdAt || '')}
                              </Typography>
                            </Grid>
                          )}

                          {/* <KeyValue title={'Name Of Entity'} description={applicant.nameOfEntity} />
                      <KeyValue
                        title={'Date Of Incorporation'}
                        description={applicant.dateOfIncorporation?.split(' ')[0]}
                      />
                      <KeyValue
                        title={'City Of Incorporation'}
                        description={applicant.cityOfIncorporation}
                      />
                      <KeyValue
                        title={'Entity Excemption Code'}
                        description={applicant.entityExcemptionCode}
                      /> */}
                        </>
                      )}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
